import React from "react";
import ExportModal from "../../../../Components/Export/ExportModal";

export interface ExpenseExportItem {
  type: string;
  id: number | string;
  amount: number;
  description: string;
  date: string;
  dateObj: Date;
  agent: string;
  status: string;
}

const COLUMN_KEYS = ["type", "amount", "description", "date", "agent", "status"] as const;
const COLUMN_LABELS: Record<string, string> = {
  type: "Type",
  amount: "Amount",
  description: "Description",
  date: "Date",
  agent: "Agent",
  status: "Status",
};

/**
 * Custom processor so exported file has readable headers and only selected columns.
 * Returns a 2D array: first row = headers, rest = data rows.
 */
function expensesDataProcessor(
  data: ExpenseExportItem[] | null | undefined,
  selectedColumns: string[]
): string[][] {
  if (!data || !Array.isArray(data)) return [];
  if (selectedColumns.length === 0) return [];

  const headerRow = selectedColumns.map((col) => COLUMN_LABELS[col] ?? col);
  const dataRows = data.map((item) =>
    selectedColumns.map((col) => {
      const value = (item as unknown as Record<string, unknown>)[col];
      if (value === undefined || value === null) return "";
      if (typeof value === "number") return String(value);
      return String(value);
    })
  );
  return [headerRow, ...dataRows];
}

export interface ExpensesExportModalProps {
  isOpen: boolean;
  onClose: () => void;
  data: ExpenseExportItem[];
}

const ExpensesExportModal: React.FC<ExpensesExportModalProps> = ({
  isOpen,
  onClose,
  data,
}) => {
  return (
    <ExportModal
      isOpen={isOpen}
      onClose={onClose}
      data={data}
      filename="expenses_export"
      title="Export Expenses"
      columns={[...COLUMN_KEYS]}
      customDataProcessor={expensesDataProcessor}
    />
  );
};

export default ExpensesExportModal;
